module.exports = cptable;


//////////////////
// WEBPACK FOOTER
// external "cptable"
// module id = 1
// module chunks = 5